import React from "react";
import { useExpanded, useSortBy, useTable} from "react-table";
import styles from "./styles/EventLogs.module.css"
export function EventTable({ columns, data, filter, setFilter, handleChange}){
    const {
        getTableProps, 
        getTableBodyProps,
        headerGroups,
        rows, 
        prepareRow, 
      }= useTable({columns,data}, useSortBy, useExpanded)
    const handleSort = (value) =>{
      if (value==='Time') value='date'
      let sort = filter.sort.split('-')
      switch (sort.length){
        case 1:
          if (sort[0]===""){
            handleChange(value, "sort")
          }else if (sort[0]===value){
            handleChange("-"+value, "sort")
          } else{
            handleChange(value, "sort")
          }
          break
        case 2:
          if (sort[1]===value){
            handleChange("", "sort")
          }else{
            handleChange(value, "sort")
          }
          break
        default:
          break
      }
    }
    return(
      <>
      <table {...getTableProps()} className={styles.sub_table_div}>
        <thead>
            {headerGroups.map(headerGroup => (
              <tr className={styles.head_row} {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map(column => (
                  <th className={styles.th} {...column.getHeaderProps(column.getSortByToggleProps())}>
                    <div className={styles.header}>
                    <span onClick={()=>{handleSort(column.id)}}>{column.render("Header")}</span>
                      {/* {column.isSorted? (column.isSortedDesc?'🔽':'🔼'):''} */}
                      {
                        filter.sort.includes(column.id)
                        ? (filter.sort.includes('-')?<div className={styles.sort_down}></div>:<div className={styles.sort_up}></div>)
                        :<div className={styles.sort_neutral}></div>
                      }                      
                    </div>
                  </th>
                  ))}
              </tr>
            ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
              prepareRow(row);
              return (
                <React.Fragment key={row.getRowProps().key}>
                    <tr className={styles.row}>
                      {row.cells.map((cell) => {
                          return (
                            <td className={styles.td} {...cell.getCellProps()}{...row.getToggleRowExpandedProps({ title: undefined })}>{cell.render("Cell")}</td>
                          );
                      })
                      }
                    </tr>
                    {/* {row.isExpanded ? <div>Row is expanded, here you can return any other component or HTML fragment</div> : null} */}
                </React.Fragment>
              );
            })}
        </tbody>
    </table>
    </>
    )
}